import { type I18Lang, isSupportedLang, type SupportedLang } from 'app/lang';
import { isSSR } from 'app/packages/components';

import { $global } from './$global';
import createClientConfig from './createClientConfig';

// ---

const {
  setConfig: saveStakesNamesTemplates,
  getConfig: getStakesNamesTemplates,
} = createClientConfig<StakesNamesTemplates>('STAKES_NAMES_TEMPLATES');

export { saveStakesNamesTemplates, getStakesNamesTemplates };

type StakeType = string;
type BetKey = string;
type Names = {
  long?: string;
  short?: string;
  full?: string;
};

type TemplatesData = Record<StakeType, {
  id: StakeType;
  names: Names;
  bets: Record<BetKey, Names>;
}>;

type StakesNamesTemplates = {
  version: number;
  data: Record<SupportedLang, TemplatesData>;
};

export function getStakesNamesTemplatesByLang(lang: I18Lang): TemplatesData | null {
  let templates;

  if (isSSR) {
    templates = $global('STAKES_NAMES_TEMPLATES');
  }
  else {
    templates = getStakesNamesTemplates();
  }

  const hasTemplatesData = templates && (lang in templates.data);

  if (!isSupportedLang(lang) || !hasTemplatesData) {
    return null;
  }

  return templates.data[lang];
}
